export default "__VITE_ASSET__a96a6e40__"